import { ApacDetailService } from './../apac-detail.service';
import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { sortBy, get, lowerCase, includes, chain } from 'lodash';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private service: ApacDetailService) { }

  detailProviderList: any[] = [];
  detailBuList: any[] = [];
  summaryReport: any;
  loading: boolean = false;
  chinaReport: any = {
    active_wechat_union_id: "",
    active_wechat_open_id: "",
    active_koplus_member: "",
    active_ali_open_id: "",
    active_phone_number: "",
    total_wechat_union_id: "",
    total_wechat_open_id: "",
    total_koplus_member: "",
    total_ali_open_id: "",
    total_phone_number: "",
    incremental_wechat_union_id: "",
    incremental_wechat_open_id: "",
    incremental_koplus_member: "",
    incremental_ali_open_id: "",
    incremental_phone_number: ""
  };
  japanReport:any = {
    apple_id: "",
    dob_members: "",
    gender_members: "",
    janrain_uuid_members: "",
    line_id_members: "",
    maid: ""
  }
  koreaReport:any = {
    phone_members: 0,
    pii_members: 0,
    geo_members: 0,
    gender_members: 0,
    dob_members: 0,
    email_members: 0
  }

  ngOnInit() {
    
    this.loading = true;
    this.activatedRoute.queryParams.subscribe(res => {
      if (res) {
        this.summaryReport = res;
        if (this.summaryReport.provider === "China") {
          this.service.getVolumesDetail({
            month: 'China', type: 'total'
          }).subscribe(res => {
            const key = this.summaryReport.provider + this.summaryReport.month;
            const list = res['items'];
            this.chinaReport = list.find(x => x.date_month_key === key).china_det;
          })
        }
        if (this.summaryReport.provider === "Japan") {
          this.service.getVolumesDetail({
            month: 'Japan', type: 'total'
          }).subscribe(res => {
            const key = this.summaryReport.provider + this.summaryReport.month;
            const list = res['items'];
            this.japanReport = list.find(x => x.date_month_key === key).japan_det;
          })
        }
        if (this.summaryReport.provider === "Korea") {
          this.service.getVolumesDetail({
            month: 'Korea', type: 'total'
          }).subscribe(res => {
            const key = this.summaryReport.provider + this.summaryReport.month;
            const list = res['items'];
            this.koreaReport = list.find(x => x.date_month_key === key);
          })
        }
        this.service.getVolumesDetail({ month: res.month, type: 'detail' }).subscribe(value => {
          if (value) {
            this.detailProviderList = value['items'].filter(result => {
              if (result.det_type == 'false') {
                return result.det_type;
              }
              this.detailBuList.push(result);
            });
            this.loading = false;
          }
        }, error => {
          this.loading = false;
          return error;
        });
      }
    }, err => {
      this.loading = false;
      return err;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/modules/apac-detail/detail/detail.component.ts